module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Please let us know your social handles.\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('div', [_c('label', [_vm._v("Instagram")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.instagramHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "instagramHandle", $$v)
      },
      expression: "updateData.instagramHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("TikTok")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.tiktokHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "tiktokHandle", $$v)
      },
      expression: "updateData.tiktokHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "#1877F2",
      "small": ""
    }
  }, [_vm._v("mdi-facebook")]), _vm._v("\n          Facebook\n        ")], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "@handle or facebook.com/handle",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.facebookHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "facebookHandle", $$v)
      },
      expression: "updateData.facebookHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Youtube")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.youtubeHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "youtubeHandle", $$v)
      },
      expression: "updateData.youtubeHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "#0A66C2",
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v("\n          LinkedIn\n        ")], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "@handle or linkedin.com/in/handle",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.linkedinHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "linkedinHandle", $$v)
      },
      expression: "updateData.linkedinHandle"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-flex align-center"
  }, [_c('img', {
    staticClass: "mr-1",
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "14",
      "height": "14",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v("\n          X (Twitter)\n        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "type": "text",
      "placeholder": "@handle or x.com/handle",
      "outlined": ""
    },
    model: {
      value: (_vm.updateData.twitterHandle),
      callback: function($$v) {
        _vm.$set(_vm.updateData, "twitterHandle", $$v)
      },
      expression: "updateData.twitterHandle"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": !_vm.updateData.instagramHandle && !_vm.updateData.tiktokHandle && !_vm.updateData.youtubeHandle && !_vm.updateData.facebookHandle && !_vm.updateData.linkedinHandle && !_vm.updateData.twitterHandle
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aefac0bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/UpdatePlatformModal.vue
// module id = 2265
// module chunks = 0